import * as React from "react";

const Trash: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="14">
            <path
                fill="currentColor"
                d="M3.75 0.5L3.4499998 0.5L3.28125 0.75078154L2.1984377 2.375L1.875 2.375L0.75 2.375L0 2.375L0 3.5L0.75 3.5L0.75 11.375L0.75 12.5L1.875 12.5L8.625 12.5L9.75 12.5L9.75 11.375L9.75 3.5L10.5 3.5L10.5 2.375L9.75 2.375L8.625 2.375L8.3015633 2.375L7.21875 0.75078154L7.0499997 0.5L6.75 0.5L3.75 0.5ZM6.9492188 2.375L3.5507812 2.375L4.0500002 1.625L6.4500003 1.625L6.9492188 2.375ZM1.875 11.375L1.875 3.5L8.625 3.5L8.625 11.375L1.875 11.375ZM3.75 5L3.75 4.625L3 4.625L3 5L3 9.875L3 10.25L3.75 10.25L3.75 9.875L3.75 5ZM5.625 5L5.625 4.625L4.875 4.625L4.875 5L4.875 9.875L4.875 10.25L5.625 10.25L5.625 9.875L5.625 5ZM7.5 5L7.5 4.625L6.75 4.625L6.75 5L6.75 9.875L6.75 10.25L7.5 10.25L7.5 9.875L7.5 5Z"
            />
        </svg>
    );
};

export default React.memo(Trash);
